import { Paragraph } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import UploadDocumento from '../UploadDocumento';
import { Container } from './styles';

function SubtitleDocumento({
  editing,
  anexarEnable,
  numAnexo,
  tipoDocumento,
  tipoDocumentoDescricao,
  protocolo,
  documentos,
}) {
  return (
    <Container>
      {documentos.map((documento, index, array) => {
        const {
          id,
          tipoDocumentoDescricao: descricao,
          dataCriacao,
          tipoDocumento: tipo,
          idUsuarioShipper,
        } = documento;

        const descriacaoIndex =
          numAnexo > 1 || array.length > 1 ? `${descricao} 0${index + 1}` : '';

        const subtitle = descriacaoIndex
          ? `${descriacaoIndex} - ${dataCriacao}`
          : dataCriacao;

        const file = new File([], descriacaoIndex || descricao, {
          type: 'application/pdf',
          lastModified: Date.now(),
        });

        const renderLabel = (
          <Paragraph key={id} style={{ marginBottom: 5 }} variant="p2">
            {subtitle}
          </Paragraph>
        );
        const renderUpdate = (
          <UploadDocumento
            key={id}
            idDocumnetoDefault={id}
            fileDefault={file}
            tipoDocumentoDescricao={descricao}
            protocolo={protocolo}
            tipoDocumento={tipo}
          />
        );

        return editing && !!idUsuarioShipper ? renderUpdate : renderLabel;
      })}

      {anexarEnable && (!documentos.length || documentos.length < numAnexo) && (
        <UploadDocumento
          tipoDocumentoDescricao={tipoDocumentoDescricao}
          protocolo={protocolo}
          tipoDocumento={tipoDocumento}
        />
      )}
      {!documentos.length && !anexarEnable && <p>Sem anexos</p>}
    </Container>
  );
}

const documento = PropTypes.shape({
  id: PropTypes.string,
  tipoDocumentoDescricao: PropTypes.string,
  tipoDocumento: PropTypes.number.isRequired,
  dataCriacao: PropTypes.string,
  isMaxicon: PropTypes.bool,
  link: PropTypes.string,
  idUsuario: PropTypes.number,
  idUsuarioShipper: PropTypes.number,
});

SubtitleDocumento.propTypes = {
  editing: PropTypes.bool.isRequired,
  anexarEnable: PropTypes.bool.isRequired,
  numAnexo: PropTypes.number.isRequired,
  tipoDocumento: PropTypes.number.isRequired,
  tipoDocumentoDescricao: PropTypes.string.isRequired,
  protocolo: PropTypes.string.isRequired,
  documentos: PropTypes.arrayOf(documento),
};

SubtitleDocumento.defaultProps = {
  documentos: [],
};

export default SubtitleDocumento;
